<head>
  <title>Forms and logs</title>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="row">
  <div class="col-md-6">
    <div class="row"><app-breadcrumb></app-breadcrumb></div>
    <div class="row">
      <div class="col-md-6">
        <div>
          <label for="email" id="selectedTemplateId"><b>Select Template </b><span
              class="mandatory-symbol">*</span>:</label>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedTemplateType"
          (closed)="templateTypeSearchText = ''" (click)="focusSearch('template-type-search')"
          (keydown.enter)="focusSearch('template-type-search')">
          <input type="search" id="template-type-search" class="dropdownsearchstyle"
            [(ngModel)]="templateTypeSearchText" matInput placeholder="Search" />
          <mat-option [value]="null" class="unselectStyle" (onSelectionChange)="onGroupValueSelect($event, null)">
            Un-select
          </mat-option>
          <mat-option *ngFor="let item of templateDropDown | assessmentSearch : templateTypeSearchText"
            (onSelectionChange)="onGroupValueSelect($event, item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row" d-flex align-items-center>
      <br />
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate</button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6">
    <div class="d-flex justify-content-between mt-4">
      <div class="d-flex gap-2 align-items-center report" [ngClass]="{
          active: this.qmsservice.formsAndLogsReportFor === 'Default'
        }" (click)="moreFormsAndLogsReportDetails('Default')"
        (keydown.enter)="moreFormsAndLogsReportDetails('Default')">
        <div class="reports_block">
          <img src="../../assets/img/DMS/circle.png" width="16px" height="16px" alt="Default" />
        </div>
        <p class="report_subtext">Default</p>
      </div>
      <div class="d-flex gap-2 align-items-center report" [ngClass]="{
          active: this.qmsservice.formsAndLogsReportFor === 'Form Section Data'
        }" (click)="moreFormsAndLogsReportDetails('Form Section Data')"
        (keydown.enter)="moreFormsAndLogsReportDetails('Form Section Data')">
        <div class="reports_block">
          <img src="../../assets/img/download-cloud.png" width="16px" height="16px" alt="Form Section Data" />
        </div>
        <p class="report_subtext">Form Section Data</p>
      </div>
      <div class="d-flex gap-2 align-items-center report" [ngClass]="{
          active: this.qmsservice.formsAndLogsReportFor === 'Template Vs Users'
        }" (click)="moreFormsAndLogsReportDetails('Template Vs Users')"
        (keydown.enter)="moreFormsAndLogsReportDetails('Template Vs Users')" style="cursor: pointer">
        <div class="reports_block">
          <img src="../../assets/img/web-design.png" width="16px" height="16px" alt="Template Vs Users" />
        </div>
        <p class="report_subtext">Template Vs Users</p>
      </div>
    </div>

    <div class="d-flex justify-content-between mt-4">
      <div class="d-flex gap-2 align-items-center report" [ngClass]="{
          active: this.qmsservice.formsAndLogsReportFor === 'Forms Vs Users'
        }" (click)="moreFormsAndLogsReportDetails('Forms Vs Users')"
        (keydown.enter)="moreFormsAndLogsReportDetails('Forms Vs Users')" style="cursor: pointer">
        <div class="reports_block">
          <img src="../../assets/img/work.png" width="16px" height="16px" alt="Forms Vs Users" />
        </div>
        <p class="report_subtext">Forms Vs Users</p>
      </div>
    </div>
  </div>
</div>
<hr />
<div class="row" *ngIf="showCharts">
  <div class="d-flex gap-5" *ngIf="selectedTemplateType == 'All'">
    <div class="col-md-12 border rounded-4 p-2 mb-3" *ngIf="templateStatusList.length > 0">
      <canvasjs-chart [options]="chartOptionsForTemplateStatus"
        [styles]="{ width: '100%', height: '350px' }"></canvasjs-chart>
    </div>
    <div class="col-md-12 border rounded-4 p-2 mb-3" *ngIf="templateStatusList.length == 0">
      <label for=" " style="
          text-align: left;
          font-size: 20px;
          font-weight: normal;
          font-family: 'Poppins', sans-serif;
          color: #0f3659;
        "><b>Status</b></label>
      <span style="
          width: 100%;
          height: 220px;
          display: block;
          text-align: center;
          font-weight: bold;
        ">
        <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px" /></span>
    </div>
  </div>

  <div class="d-flex gap-5" *ngIf="selectedTemplateType != 'All'">
    <div class="col-md-6 border rounded-4 p-2 mb-3" *ngIf="formsTemplateNameList.length > 0">
      <canvasjs-chart [options]="chartOptionsForFormsStatus" [styles]="{ width: '100%', height: '220px' }"
        (dblclick)="formsAndLogsChartDoubleClick(2)"></canvasjs-chart>
    </div>
    <div class="col-md-6 border rounded-4 p-2 mb-3" *ngIf="formsTemplateNameList.length == 0">
      <label for=" " style="
          text-align: left;
          font-size: 20px;
          font-weight: normal;
          font-family: 'Poppins', sans-serif;
          color: #0f3659;
        "><b>Status</b></label>
      <span style="
          width: 100%;
          height: 220px;
          display: block;
          text-align: center;
          font-weight: bold;
        ">
        <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px" /></span>
    </div>

    <div class="col-md-6 border rounded-4 p-2 mb-3" *ngIf="formsSectionDataStatusList.length > 0">
      <canvasjs-chart [options]="chartOptionsForFormsSectionDataStatus" [styles]="{ width: '100%', height: '220px' }"
        (dblclick)="formsAndLogsChartDoubleClick(3)"></canvasjs-chart>
    </div>
    <div class="col-md-6 border rounded-4 p-2 mb-3" *ngIf="formsSectionDataStatusList.length == 0">
      <label for="" style="
          text-align: left;
          font-size: 20px;
          font-weight: normal;
          font-family: 'Poppins', sans-serif;
          color: #0f3659;
        "><b>Status</b></label>
      <span style="
          width: 100%;
          height: 220px;
          display: block;
          text-align: center;
          font-weight: bold;
        ">
        <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px" /></span>
    </div>
  </div>
</div>

<div class="table-container" *ngIf="selectedTemplateType == 'All' && showCharts">
  <div class="row">
    <div class="col-8"></div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
      <i class="fa fa-file-excel-o" style="font-size: 18px; color: white"></i>
      <span class="reload_text text-white">Excel Report</span>
    </div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
      <i class="fa fa-file-pdf-o" style="font-size: 18px; color: white"></i>
      <span class="reload_text text-white">PDF Report</span>
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="table-container">
    <table style="height: 60vh">
      <thead>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Template Name</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter('templateName', $event, 's')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Template Description</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter('templateDescription', $event, 's')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Status</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('status', $event, 's')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>ListOf Stages</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter('listOfStages', $event, 's')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Allow To Add New Form</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter('allowToAddNewForm', $event, 's')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Approval Requested On</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter('approvalRequestedOnStr', $event, 'd')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Approved On</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter('approvedOnStr', $event, 'd')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Approved By User</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter('approvedUserByUser', $event, 's')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Approver Comments</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter('approverComments', $event, 's')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Created On</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter('createdOnStr', $event, 'd')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Created By User</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter('createdByUser', $event, 's')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Updated On</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter('updatedOnStr', $event, 'd')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Updated By User</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter('updatedByUser', $event, 's')" />
          </div>
        </th>
        <th class="sticky-col first-col"></th>
      </thead>
      <tr *ngIf="pagedItems.length === 0">
        <td class="row-data text-center" colspan="15">No records found</td>
      </tr>
      <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems; let idx = index">
        <td class="row-data">{{ listOfUsersData.templateName }}</td>
        <td class="row-data">{{ listOfUsersData.templateDescription }}</td>
        <td class="row-data">{{ listOfUsersData.status }}</td>
        <td class="row-data">{{ listOfUsersData.listOfStages }}</td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.allowToAddNewForm === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
              height="20" alt="Access granted symbol" />
            <img *ngIf="listOfUsersData.allowToAddNewForm === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
              height="20" alt="Access granted symbol" />
          </div>
        </td>
        <td class="row-data">{{ listOfUsersData.approvalRequestedOnStr }}</td>
        <td class="row-data">{{ listOfUsersData.approvedOnStr }}</td>
        <td class="row-data">{{ listOfUsersData.approvedUserByUser }}</td>
        <td class="row-data">{{ listOfUsersData.approverComments }}</td>
        <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
        <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
        <td class="row-data">{{ listOfUsersData.updatedOnStr }}</td>
        <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>
      </tr>
    </table>
  </div>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>
</div>
<!--detail grid-->
<ng-template #reportPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopupFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">{{ clickedType }} : {{ clickedVal }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>

  <div class="table-container" *ngIf="showReportFlagValue == '3'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size: 18px; color: white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size: 18px; color: white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>
    &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh">
        <thead>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Section Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('sectionName', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Form Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('formName', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('status', $event, 's')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Verified</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('isVerified', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Verification Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="
                  applyFilter2('verificationRequestedOnStr', $event, 'd')
                " />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Verified By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('verifiedByUser', $event, 's')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Verified On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('verifiedOnStr', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Verifier Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('verifierComments', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Withdrawal Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('withdrawalRequestedOnStr', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Withdrawn By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('withdrawnByUser', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Withdrawn On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('withdrawOnStr', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Withdrawer Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('withdrawerComments', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('createdOnStr', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('createdByUser', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('updatedOnStr', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('updatedByUser', $event, 's')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>
        <tr *ngIf="pagedItems2.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems2; let idx = index">
          <td class="row-data">{{ listOfUsersData.sectionName }}</td>
          <td class="row-data">{{ listOfUsersData.formName }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isVerified === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol" />
              <img *ngIf="listOfUsersData.isVerified === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol" />
            </div>
          </td>
          <td class="row-data">
            {{ listOfUsersData.verificationRequestedOnStr }}
          </td>
          <td class="row-data">{{ listOfUsersData.verifiedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.verifiedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.verifierComments }}</td>
          <td class="row-data">{{ listOfUsersData.withdrawalRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.withdrawnByUser }}</td>
          <td class="row-data">{{ listOfUsersData.withdrawOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.withdrawerComments }}</td>
          <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
          <td class="row-data">{{ listOfUsersData.updatedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>
        </tr>
      </table>
    </div>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage2(pager.currentPage, $event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCall2(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall2(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall2(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue == '2'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size: 18px; color: white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size: 18px; color: white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>
    &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh">
        <thead>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Form Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('formName', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Form Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('formDescription', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Template Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('templateName', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Template Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('templateDescription', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('status', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Header</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('header', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Footer</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('footer', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('lastActionOnStr', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('lastActionComments', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action From Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('lastActionFromStatus', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('lastActionByUser', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Locked On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('lockedOnStr', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Locked Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('lockedComments', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('completedOnStr', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('createdOnStr', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('createdByUser', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('updatedOnStr', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('updatedByUser', $event, 's')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>
        <tr *ngIf="pagedItems1.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems1; let idx = index">
          <td class="row-data">{{ listOfUsersData.formName }}</td>
          <td class="row-data">{{ listOfUsersData.formDescription }}</td>
          <td class="row-data">{{ listOfUsersData.templateName }}</td>
          <td class="row-data">{{ listOfUsersData.templateDescription }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'HEADER',listOfUsersData.header,'ONEQMS_FORMS_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'FOOTER',listOfUsersData.footer,'ONEQMS_FORMS_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.lastActionOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionComments }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionFromStatus }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionByUser }}</td>
          <td class="row-data">{{ listOfUsersData.lockedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.lockedComments }}</td>
          <td class="row-data">{{ listOfUsersData.completedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
          <td class="row-data">{{ listOfUsersData.updatedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>
        </tr>
      </table>
    </div>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage, $event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue == '1'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size: 18px; color: white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size: 18px; color: white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>
    &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh">
        <thead>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Template Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('templateName', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Template Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('templateDescription', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('status', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>ListOf Stages</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('listOfStages', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Allow To Add New Form</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('allowToAddNewForm', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approval Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('approvalRequestedOnStr', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('approvedOnStr', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approved By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('approvedUserByUser', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approver Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('approverComments', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('createdOnStr', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('createdByUser', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('updatedOnStr', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('updatedByUser', $event, 's')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>
        <tr *ngIf="pagedItems.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems; let idx = index">
          <td class="row-data">{{ listOfUsersData.templateName }}</td>
          <td class="row-data">{{ listOfUsersData.templateDescription }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.listOfStages }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.allowToAddNewForm === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol" />
              <img *ngIf="listOfUsersData.allowToAddNewForm === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol" />
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.approvalRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.approvedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.approvedUserByUser }}</td>
          <td class="row-data">{{ listOfUsersData.approverComments }}</td>
          <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
          <td class="row-data">{{ listOfUsersData.updatedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>
        </tr>
      </table>
    </div>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCall(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopupFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #reportPopupForZoom>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopupForZoomFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"></label>
    <label for="app-name" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div class="row">
    <div class="col-md-12 border rounded-4 p-2 mb-3" *ngIf="clickedChartVal == 2">
      <canvasjs-chart [options]="chartOptionsForFormsStatusZoom"
        [styles]="{ width: '100%', height: '550px' }"></canvasjs-chart>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 border rounded-4 p-2 mb-3" *ngIf="clickedChartVal == 3">
      <canvasjs-chart [options]="chartOptionsForFormsSectionDataStatusZoom"
        [styles]="{ width: '100%', height: '550px' }"></canvasjs-chart>
    </div>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue == '3'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size: 18px; color: white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size: 18px; color: white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>
    &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh">
        <thead>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Section Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('sectionName', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Form Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('formName', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('status', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Verified</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('isVerified', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Verification Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="
                  applyFilter2('verificationRequestedOnStr', $event, 'd')
                " />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Verified By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('verifiedByUser', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Verified On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('verifiedOnStr', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Verifier Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('verifierComments', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Withdrawal Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('withdrawalRequestedOnStr', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Withdrawn By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('withdrawnByUser', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Withdrawn On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('withdrawOnStr', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Withdrawer Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('withdrawerComments', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Locked By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('lockedByUser', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('createdOnStr', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('createdByUser', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('updatedOnStr', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('updatedByUser', $event, 's')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>
        <tr *ngIf="pagedItems2.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems2; let idx = index">
          <td class="row-data">{{ listOfUsersData.sectionName }}</td>
          <td class="row-data">{{ listOfUsersData.formName }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isVerified === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol" />
              <img *ngIf="listOfUsersData.isVerified === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol" />
            </div>
          </td>
          <td class="row-data">
            {{ listOfUsersData.verificationRequestedOnStr }}
          </td>
          <td class="row-data">{{ listOfUsersData.verifiedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.verifiedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.verifierComments }}</td>
          <td class="row-data">{{ listOfUsersData.withdrawalRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.withdrawnByUser }}</td>
          <td class="row-data">{{ listOfUsersData.withdrawOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.withdrawerComments }}</td>
          <td class="row-data">{{ listOfUsersData.lockedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
          <td class="row-data">{{ listOfUsersData.updatedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>
        </tr>
      </table>
    </div>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage2(pager.currentPage, $event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCall2(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall2(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall2(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue == '2'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size: 18px; color: white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size: 18px; color: white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>
    &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh">
        <thead>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Form Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('formName', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Form Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('formDescription', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Template Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('templateName', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Template Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('templateDescription', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('status', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Header</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('header', $event, 's')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Footer</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('footer', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('lastActionOnStr', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('lastActionComments', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action From Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('lastActionFromStatus', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('lastActionByUser', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Locked On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('lockedOnStr', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Locked Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('lockedComments', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('completedOnStr', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('createdOnStr', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('createdByUser', $event, 's')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('updatedOnStr', $event, 'd')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('updatedByUser', $event, 's')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>
        <tr *ngIf="pagedItems1.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems1; let idx = index">
          <td class="row-data">{{ listOfUsersData.formName }}</td>
          <td class="row-data">{{ listOfUsersData.formDescription }}</td>
          <td class="row-data">{{ listOfUsersData.templateName }}</td>
          <td class="row-data">{{ listOfUsersData.templateDescription }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.header }}</td>
          <td class="row-data">{{ listOfUsersData.footer }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionComments }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionFromStatus }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionByUser }}</td>
          <td class="row-data">{{ listOfUsersData.lockedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.lockedComments }}</td>
          <td class="row-data">{{ listOfUsersData.completedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
          <td class="row-data">{{ listOfUsersData.updatedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>
        </tr>
      </table>
    </div>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage, $event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopupForZoomFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #excelPdfPopup>
  <div class="page-loading-shade" *ngIf="appService.isProcessingRep">
    <app-custom-spinner *ngIf="appService.isProcessingRep"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div style="margin: 15px 15px" class="align-center">
    <label for="email" style="font-size: medium; font-weight: bold">Do you want to generate {{ popupDataTitle.title }}
      ?</label>
  </div>
  <div style="margin: 15px 15px" class="align-center" *ngIf="!isForExcel">
    <label for="email" style="font-size: 0.7rem; font-weight: bold">
      <span *ngIf="!manuallyPicked">This report will include the first 10 columns by default</span>
      <span *ngIf="manuallyPicked && maxCountReached">
        We recommend selecting a maximum of 10 columns for a cleaner and more
        readable PDF
      </span>
    </label>
  </div>
  <div class="row" *ngIf="!isForExcel" style="margin: 10px 10px 7% 10px">
    <div class="col-md-12" *ngIf="selectedColumns.length">
      <div><label for="email">Selected Column(s)</label></div>
      <textarea id="selectedValuesTextarea" class="input-filed-textarea" style="margin-top: 8px; cursor: not-allowed"
        rows="4" cols="50" [disabled]="true" [(ngModel)]="selectedColumnsAsString"></textarea>
    </div>
    <div class="row" [ngClass]="selectedColumns.length ? 'mt-3' : ''">
      <div class="col-md-6">
        <label for="radio">PDF Page Size</label>
        <mat-radio-group [(ngModel)]="excelPdf.pdfPageSize">
          <mat-radio-button *ngFor="let data of pdfPageSizes" [value]="data.codelistCode">{{ data.codelistName
            }}</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="col-md-6" style="margin-top: 1.5%">
        <label for="toggle">Pick Columns Manually?</label>&nbsp;
        <mat-slide-toggle color="primary" (change)="onCheckboxChange($event)" [(ngModel)]="manuallyPicked" id="toggle">
          <ng-container *ngIf="manuallyPicked; else no">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43)">Yes</span>
          </ng-container>
          <ng-template #no>
            <span style="color: red">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row mt-3" *ngIf="manuallyPicked">
      <div class="col-md-12">
        <div>
          <label for="email">Select Column(s)</label><span class="mandatory-symbol">*</span>
        </div>
        <mat-select matInput multiple placeholder="Select" #pdf id="execl-pdf" [(ngModel)]="selectedColumns"
          (closed)="pdfSearchText = ''" (click)="focusSearch('focus-department-search')"
          (keydown.enter)="focusSearch('focus-department-search')">
          <input type="search" id="focus-department-search" class="dropdownsearchstyle" [(ngModel)]="pdfSearchText"
            matInput placeholder="search" />
          <div class="select-all">
            <mat-checkbox [(ngModel)]="pdfSelection" (change)="toggleAllSelection('pdf')">
              Select All</mat-checkbox>
          </div>
          <mat-option *ngFor="
              let item of excelPdf.dropDown | assessmentSearch : pdfSearchText
            " [value]="item.valueExp" (onSelectionChange)="onColumnSelect($event, item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
  </div>

  <div class="row justify-content-md-center" *ngIf="!isForExcel">
    <div class="col-sm-4">
      <label for="email">Report Logo</label>
    </div>
    <div class="col-sm-8">
      <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportLogoValue"
        (closed)="pdfDetailSearchText = ''" (click)="focusSearch('focus-Logo-search')"
        (keydown.enter)="focusSearch('focus-Logo-search')">
        <input type="search" id="focus-Logo-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
          matInput placeholder="search" />
        <mat-option [value]="null" class="unselectStyle"
          (onSelectionChange)="onReportLogoValueSelect($event, null)">Un-select</mat-option>
        <mat-option *ngFor="
            let item of reportLogoDropdown
              | assessmentSearch : pdfDetailSearchText
          " (onSelectionChange)="onReportLogoValueSelect($event, item)" [value]="item.valueExp">
          {{ item.displayExp }}
        </mat-option>
      </mat-select>
    </div>

    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter" (closed)="pdfDetailSearchText = ''"
          (click)="focusSearch('focus-Logo-search')" (keydown.enter)="focusSearch('focus-Logo-search')">
          <mat-option *ngFor="
              let item of reportFooterDropdown
                | assessmentSearch : pdfDetailSearchText
            " (onSelectionChange)="onReportFooterSelect($event, item)" [value]="item.displayExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
  </div>

  <div class="row justify-content-md-center" *ngIf="!isForExcel">
    <div class="col-sm-4">
      <label for="email">Is Save Report?</label>
    </div>
    <div class="col-sm-8">
      <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
        <ng-container *ngIf="isSaveReport; else noisSaveReport">
          <span class="active-inActive-container" style="color: rgb(43, 227, 43)">Yes</span>
        </ng-container>
        <ng-template #noisSaveReport>
          <span style="color: red">No</span>
        </ng-template>
      </mat-slide-toggle>
    </div>
  </div>
  <div class="row justify-content-md-center" *ngIf="isSaveReport">
    <div class="col-sm-4">
      <label for="email">Report Name</label><span class="mandatory-symbol">*</span>
    </div>
    <div class="col-sm-8">
      <input type="text" class="input-filed-continers" [(ngModel)]="reportName" />
    </div>
  </div>
  <div class="button-continer btn-align" style="margin-top: 3%" mat-dialog-actions>
    <button *ngIf="isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Excel')">
      <i class="fa fa-file-excel-o"></i> Generate
    </button>
    <button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Pdf')">
      <i class="fa fa-file-pdf-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<app-editor #clobViewPopup></app-editor>